<template>
  <div>
    <v-card class="pa-3">
      <div class="text-xs-right">
        <v-btn icon ripple flat @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="py-2">
        <div class="mt-2">
          <div class="caption">Ticket ID:</div>
          <div class="form-control">
            <input type="text" v-model="input.ticket_id" :placeholder="'Ticket ID'" />
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">Ticket Name:</div>
          <div class="form-control">
            <input type="text" v-model="input.ticket_name" :placeholder="'Ticket Name'" />
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">Group:</div>
          <div class="form-control mb-2">
            <multiselect
              :options="agentGroupOptions"
              label="groupname"
              v-model="input.group"
              :placeholder="'Group'"
              :max-height="250"
            >
            </multiselect>
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">SubGroup:</div>
          <div class="form-control mb-2">
            <multiselect
              :options="agentSubGroupOptions"
              v-model="input.subgroup"
              label="subgroupname"
              :placeholder="'SubGroup'"
              :max-height="250"
            >
            </multiselect>
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">Agent:</div>
          <div class="form-control">
            <multiselect
              :options="agentOptions"
              v-model="input.agent_name"
              label="name"
              :placeholder="'Agent'"
              :max-height="250"
              :openDirection="'above'"
            >
            </multiselect>
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">{{ $t('phone no.') }}</div>
          <div class="form-control">
            <input type="text" v-model="input.phone_number" :placeholder="$t('phone no.')" />
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">{{ $t('Tags') }}</div>
          <multiselect
            :options="tagOptions"
            v-model="input.tags"
            :placeholder="$t('Tags')"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
          >
          </multiselect>
        </div>
        <div class="mt-2">
          <v-layout>
            <v-flex class="pa-1">
              <v-btn block depressed @click="clearSearch">
                <v-icon>clear</v-icon>
                {{ $t('Clear All') }}
              </v-btn>
            </v-flex>
            <v-flex class="pa-1">
              <v-btn block depressed @click="onSearch" color="primary">
                <v-icon>search</v-icon>
                {{ $t('Search') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      input: {
        ticket_id: '',
        ticket_name: '',
        group: '',
        subgroup: '',
        agent_name: '',
        phone_number: '',
        email: '',
        tags: ''
      },
      tagOptions: [],
      groupOptions: [],
      subgroupOptions: []
    }
  },
  mounted() {
    this.getUserTagList()
  },
  computed: {
    ...mapGetters({
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      agent: 'getAgent',
      selectedBot: 'selectedBot',
      loadingAgentGroup: 'getLoadingAgentGroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      loadingAgent: 'getLoadingAgent'
    }),
    agentGroupOptions() {
      if (this.agentGroup && this.agentGroup.length) {
        return this.agentGroup
      } else {
        return []
      }
    },
    agentSubGroupOptions() {
      if (this.agentSubGroup && this.agentSubGroup.length) {
        return this.agentSubGroup
        // return this.agentSubGroup.filter((el) => {
        //   return el.admingroupid == this.transfer.group.id
        // })
      } else {
        return []
      }
    },
    agentOptions() {
      if (this.agent && this.agent.length) {
        return this.agent
      } else {
        return []
      }
    }
  },
  methods: {
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        response.result.map((item) => {
          this.tagOptions.push(item.name)
        })
      }
    },
    addTag(newTag) {
      const tag = newTag
      this.tagOptions.push(tag)
      this.input.tags.push(tag)
    },
    onSearch() {
      this.$emit('onSearch', this.input)
      console.log('input: ', this.input)
    },
    clearSearch() {
      this.input = {
        ticket_id: '',
        ticket_name: '',
        group: '',
        subgroup: '',
        agent_name: '',
        phone_number: '',
        email: '',
        tag: ''
      }

      this.$emit('onSearch', this.input)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket2/management/AdvancedSearch.vue